import * as React from 'react';

import { Grid,  Button, Checkbox, Link } from '@material-ui/core';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { Trans, TransProps, WithTranslation, withTranslation } from 'react-i18next';

import { window2config } from '../../cfg/config';
import CONFIG from '../../cfg/config';

import { List, ListItem, Typography, ListItemText, ListItemIcon } from '@material-ui/core';
import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState } from '../../appredux';

import { hotelService, webHotel, PortalInfo, Info, webRooms, roomsService, webRoom, passService, Bramka, Result, resetService } from '../../api';
import { ClassNameMap } from '@material-ui/styles';
import theme from '../../themes';
import SearchIcon from '@material-ui/icons/Search';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import OknoRegulamin from './OknoRegulamin';


interface DoladujKarnetProps {
  page: IPageState,
}

interface DoladujKarnetState {
  checked: boolean,
  openRegulamin: boolean
}



class DoladujKarnet extends React.Component<DoladujKarnetProps & WithTranslation & TransProps & WithStyles<typeof styles>, DoladujKarnetState> {

  constructor(props: DoladujKarnetProps & WithTranslation & WithStyles<typeof styles>) {
    super(props, {});
    window2config();
   
    this.state = {
      checked: this.props.page.regulaminZamowienia,
      openRegulamin: false
    }
  }

  componentDidMount() {
  }

  openRegulamin = () => {
    this.setState({openRegulamin: true})
  }
  closeRegulamin = () => {
    this.setState({openRegulamin: false})
  }



  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({checked: event.target.checked});
    store.dispatch(Actions.pageState.setRegulaminZamowienia(event.target.checked));
  };
  change = () => {
    this.setState({checked: !this.state.checked});
    store.dispatch(Actions.pageState.setRegulaminZamowienia(!this.state.checked));
  }

  
  render() {
    const { classes, t } = this.props;
    let primary = theme.palette.primary.main

    let disabled = !this.props.page.jestKarnet
    

      return (
          <Grid container spacing={2} className={classes.container1} justify="center" alignItems="center"  >
              <Grid item xs={12} sm={12} className={classes.gridItem} style={{paddingLeft: "0",paddingRight: "0"}}>

                <div style={{ width: "fit-content", margin: "auto" }}>
                  <Typography variant="h6" component="h2" onClick={() => this.openRegulamin()} color='textSecondary' className={`${classes.text} ${classes.color}`} style={{cursor: "pointer"}}>
                    <SearchIcon className={classes.icon} style={{marginRight: "6px"}}/>
                    {/* href="https://vsc24.net/vscHotelBook/hotel/lesko-SKI" */}
                    <Link target='_blank' underline="hover" className={classes.color} style={{ cursor: "pointer" }}>{'przeczytaj regulamin'}</Link>
                    {/* {"Ty lajkujesz"}<b className={classes.primary} >{ }</b> */}
                    {/* Twój telefon <b >{"48 60* *** *83"}</b> */}
                  </Typography>
                  <Typography variant="h6" component="h2" onClick={() => !disabled ? this.change() : store.dispatch(Actions.pageState.setOpenInfo())} color='textSecondary' className={`${classes.text} ${classes.color}`} style={{ cursor: "pointer" }}>
                    <Checkbox
                      checked={this.state.checked}
                      onChange={this.handleChange}
                      style={{ marginLeft: "-9px", color: "rgb(255, 165, 0)" }}
                      inputProps={{ 'aria-label': 'controlled' }}
                      disabled={disabled}
                    />
                    {"przeczytałem(-am)\ni akceptuję warunki zamówienia"}<b className={classes.primary} >{ }</b>
                  </Typography>

                </div>   

                <OknoRegulamin open={this.state.openRegulamin} closeDialog={this.closeRegulamin} tytul={"warunki zamówienia"}/>
              </Grid>
          </Grid>
      );
  }
}

const styles = (theme: Theme) => ({
  primary: {
    color: theme.palette.primary.main
  },
  color: {
    color: "lightseagreen",
    //color: theme.palette.primary.main
  },
  text: {
    //color: theme.palette.text.secondary,
    whiteSpace: "break-spaces" as "break-spaces",
    minHeight: "12px",
    //maxHeight: "25.6px",
    marginBottom: '12px',
    fontSize: "16px",

    display: "flex" as "flex",
    //justyfyContent: "center",
    alignItems: "center"
  },
  icon: {
    fontSize: "28px", 
    color: "rgb(255, 165, 0)", 
    marginRight: "10px"
  },
  container1: {
    //margin: "0em",
    //paddingTop: "0.4em",
    margin: "30px auto 0px",
    padding: '0em 0em',
    minHeight: "100%",
    maxWidth: "1340px",
    //border: "2px solid lavender"
  },
  gridItem: {
    minHeight: "150px",
  },
  item: {
    height: "40px",
    textAlign: "center" as "center",
    border: "1px solid lavender",
    marginBottom: "4px",
    backgroundColor: "#FCFCFC", //"#F5F5F5",
    "&:hover": {
      backgroundColor: "#F1F1F1", //"#EEE"
    },
  },
  itemText: {
    color: "rgb(255, 165, 0)",
    fontSize: "16px"//"2.5rem"
  }
 
  
 
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(DoladujKarnet))); 

